module.exports = __webpack_public_path__ + "static/media/4.6f0a7647.jpeg";